import React from 'react';
import SectionWrapper from '../atoms/SectionWrapper';
import { useTranslation } from 'react-i18next';
import ReviewList from './ReviewList';

export default function Reviews() {
  const { t } = useTranslation();
  return (
    <div data-testid="reviews-page-wrapper">
      <SectionWrapper
        title={t('reviews.title')}
        desc={t('reviews.subTitle')}
        whiteBgChildren
      >
        <ReviewList />
      </SectionWrapper>
    </div>
  );
}
